// Blog posts for FinCalc. Evergreen, editorial-grade money articles.
// Each post drives SEO + supports AdSense approval (content depth signal).
// Keep body as JSX via the `body` component render — allows richer formatting
// than Markdown for code blocks, quote styling, and internal links.

export const POSTS = [
    {
        slug: "how-much-mortgage-can-i-afford",
        title: "How Much Mortgage Can I Actually Afford in 2026?",
        description: "The 28/36 rule, take-home vs gross pay, and why the bank's maximum pre-approval is rarely the number you should borrow.",
        category: "Mortgage",
        readTime: 8,
        publishedAt: "2026-02-15",
        updatedAt: "2026-02-15",
        keywords: ["how much mortgage can I afford", "28/36 rule", "mortgage affordability 2026"],
    },
    {
        slug: "no-tax-on-overtime-tips-explained",
        title: "No Tax on Overtime and Tips: What the 2025 OBBBA Actually Means for Your Paycheck",
        description: "A plain-English breakdown of the 2025 'No Tax on Overtime' and 'No Tax on Tips' federal deductions, with real-dollar examples at $18, $22, and $28 an hour.",
        category: "Taxes",
        readTime: 10,
        publishedAt: "2026-02-18",
        updatedAt: "2026-02-18",
        keywords: ["no tax on overtime", "no tax on tips", "OBBBA 2025", "tax deduction hourly workers"],
    },
    {
        slug: "debt-snowball-vs-avalanche",
        title: "Debt Snowball vs Avalanche: Which One Actually Gets You Debt-Free Faster?",
        description: "The math says avalanche wins. The psychology says snowball wins. Here's how to pick the one that'll actually stick for your situation.",
        category: "Debt",
        readTime: 7,
        publishedAt: "2026-02-20",
        updatedAt: "2026-02-20",
        keywords: ["debt snowball vs avalanche", "pay off debt fast", "debt payoff strategy"],
    },
    {
        slug: "no-income-tax-states-actually-save",
        title: "States With No Income Tax: Are You Actually Saving Money?",
        description: "Florida, Texas, Tennessee, and the other six no-income-tax states aren't the slam-dunk savings most people assume. A worked breakdown of when the math wins and when property + sales tax cancel it out.",
        category: "Taxes",
        readTime: 9,
        publishedAt: "2026-02-25",
        updatedAt: "2026-02-25",
        keywords: ["no income tax states", "states with no income tax", "moving for taxes", "florida vs california taxes", "texas no income tax"],
    },
    {
        slug: "first-time-buyer-fha-va-conventional",
        title: "First-Time Homebuyer Guide: FHA vs Conventional vs VA Loans in 2026",
        description: "FHA, VA, and conventional loans aren't equivalent — the lifetime cost can differ by $30K–$60K. A plain-English decision tree for picking the right loan for your credit, down payment, and eligibility.",
        category: "Mortgage",
        readTime: 11,
        publishedAt: "2026-02-28",
        updatedAt: "2026-02-28",
        keywords: ["fha vs conventional", "va loan vs conventional", "first time home buyer loan", "best mortgage for first time buyer", "fha vs va vs conventional"],
    },
    {
        slug: "how-to-pay-off-credit-card-debt-fast",
        title: "How to Pay Off Credit Card Debt Fast (Without Gimmicks)",
        description: "Skip the balance transfer tricks. Here's the math on what actually gets you out of credit card debt — and how long it takes.",
        category: "Debt",
        readTime: 6,
        publishedAt: "2026-03-05",
        updatedAt: "2026-06-01",
        keywords: ["pay off credit card debt fast", "credit card payoff", "get out of debt"],
    },
    {
        slug: "what-is-a-good-interest-rate-on-a-car-loan",
        title: "What Is a Good Interest Rate on a Car Loan in 2026?",
        description: "Average auto loan rates in 2026 by credit score, loan term, and new vs used. Know the number before you walk into the dealership.",
        category: "Loans",
        readTime: 5,
        publishedAt: "2026-03-10",
        updatedAt: "2026-06-01",
        keywords: ["good interest rate car loan", "auto loan rates 2026", "car loan interest rate"],
    },
    {
        slug: "heloc-vs-home-equity-loan",
        title: "HELOC vs Home Equity Loan: Which One Is Right for You?",
        description: "Both tap your home equity but work very differently. Here's how to pick the right one based on how you plan to use the money.",
        category: "Loans",
        readTime: 6,
        publishedAt: "2026-03-15",
        updatedAt: "2026-06-01",
        keywords: ["heloc vs home equity loan", "home equity loan", "heloc"],
    },
    {
        slug: "how-much-should-i-save-for-retirement",
        title: "How Much Should I Save for Retirement? The Honest Answer",
        description: "The 15% rule is a starting point, not a guarantee. Here's how to calculate what you actually need based on your income and timeline.",
        category: "Invest",
        readTime: 7,
        publishedAt: "2026-03-20",
        updatedAt: "2026-06-01",
        keywords: ["how much to save for retirement", "retirement savings", "retirement calculator"],
    },
    {
        slug: "fha-vs-conventional-loan",
        title: "FHA vs Conventional Loan: Which One Saves You More?",
        description: "FHA loans are easier to qualify for but cost more over time. Here's the real math on which loan type wins at different down payment levels.",
        category: "Loans",
        readTime: 6,
        publishedAt: "2026-03-25",
        updatedAt: "2026-06-01",
        keywords: ["fha vs conventional loan", "fha loan", "conventional loan"],
    },
    {
        slug: "how-to-negotiate-salary",
        title: "How to Negotiate Salary: A Numbers-First Playbook",
        description: "Most people leave money on the table because they anchor too low or too late. Here's how to run the numbers and make the ask.",
        category: "Everyday",
        readTime: 6,
        publishedAt: "2026-04-01",
        updatedAt: "2026-06-01",
        keywords: ["how to negotiate salary", "salary negotiation", "ask for a raise"],
    },
    {
        slug: "compound-interest-explained",
        title: "Compound Interest Explained With Real Numbers",
        description: "Compound interest is the most powerful force in personal finance. Here's exactly how it works and why starting early matters so much.",
        category: "Invest",
        readTime: 5,
        publishedAt: "2026-04-05",
        updatedAt: "2026-06-01",
        keywords: ["compound interest explained", "how compound interest works", "compound interest calculator"],
    },
    {
        slug: "rent-or-buy-calculator-guide",
        title: "Rent or Buy? How to Run the Numbers for Your Situation",
        description: "The rent vs buy decision isn't just about monthly payments. Here's the full cost comparison most people miss.",
        category: "Loans",
        readTime: 7,
        publishedAt: "2026-04-10",
        updatedAt: "2026-06-01",
        keywords: ["rent or buy", "rent vs buy calculator", "should I buy a house"],
    },
    {
        slug: "va-loan-benefits-explained",
        title: "VA Loan Benefits Explained: What You Actually Get",
        description: "No down payment, no PMI, competitive rates — but VA loans have limits and fees most people don't know about. Here's the full picture.",
        category: "Loans",
        readTime: 6,
        publishedAt: "2026-04-15",
        updatedAt: "2026-06-01",
        keywords: ["va loan benefits", "va home loan", "va loan requirements"],
    },
    {
        slug: "what-is-roi",
        title: "What Is ROI and How Do You Calculate It?",
        description: "ROI is the most misused metric in investing. Here's the correct formula, common mistakes, and how to actually use it.",
        category: "Invest",
        readTime: 5,
        publishedAt: "2026-04-20",
        updatedAt: "2026-06-01",
        keywords: ["what is roi", "return on investment", "roi formula"],
    },
    {
        slug: "how-to-calculate-tip",
        title: "How to Calculate a Tip Without Getting It Wrong",
        description: "The quick mental math method, standard tip percentages by service type, and when to tip on the pre-tax vs post-tax total.",
        category: "Everyday",
        readTime: 5,
        publishedAt: "2026-04-25",
        updatedAt: "2026-06-01",
        keywords: ["how to calculate tip", "tip calculator", "how much to tip"],
    },
    {
        slug: "jumbo-loan-requirements-2026",
        title: "Jumbo Loan Requirements in 2026: What Lenders Actually Want",
        description: "Jumbo loans have stricter credit, income, and reserve requirements than conforming loans. Here's what you need to qualify.",
        category: "Loans",
        readTime: 6,
        publishedAt: "2026-05-01",
        updatedAt: "2026-06-01",
        keywords: ["jumbo loan requirements", "jumbo mortgage", "jumbo loan 2026"],
    },
    {
        slug: "savings-goal-how-long",
        title: "How Long Will It Take to Reach Your Savings Goal?",
        description: "The math behind savings timelines — how interest rate, contribution amount, and starting balance interact to get you to your number.",
        category: "Everyday",
        readTime: 5,
        publishedAt: "2026-05-05",
        updatedAt: "2026-06-01",
        keywords: ["savings goal calculator", "how long to save", "savings timeline"],
    },
    {
        slug: "simple-interest-vs-compound",
        title: "Simple Interest vs Compound Interest: The Key Difference",
        description: "Simple interest is linear. Compound interest is exponential. Here's what that means for your loans and your savings.",
        category: "Everyday",
        readTime: 5,
        publishedAt: "2026-05-10",
        updatedAt: "2026-06-01",
        keywords: ["simple interest vs compound interest", "simple interest", "compound interest"],
    },
    {
        slug: "mortgage-refinance-when-worth-it",
        title: "When Is Refinancing Your Mortgage Actually Worth It?",
        description: "The break-even calculation lenders don't advertise. Here's how to know if refinancing saves you money or just resets your clock.",
        category: "Loans",
        readTime: 6,
        publishedAt: "2026-05-15",
        updatedAt: "2026-06-01",
        keywords: ["when to refinance mortgage", "mortgage refinance", "refinance break even"],
    },
    {
        slug: "income-tax-brackets-2026",
        title: "US Federal Income Tax Brackets for 2026: What You'll Actually Pay",
        description: "The 2026 federal tax brackets with real examples. Understand marginal vs effective tax rate so you know what you actually owe.",
        category: "Taxes",
        readTime: 6,
        publishedAt: "2026-05-20",
        updatedAt: "2026-06-01",
        keywords: ["tax brackets 2026", "federal income tax 2026", "marginal tax rate"],
    },
    {
        slug: "how-to-get-out-of-debt",
        title: "How to Get Out of Debt: A Step-by-Step Plan That Works",
        description: "A practical, no-fluff debt payoff plan covering budgeting, prioritization, and the math behind getting to zero.",
        category: "Debt",
        readTime: 8,
        publishedAt: "2026-05-25",
        updatedAt: "2026-06-01",
        keywords: ["how to get out of debt", "debt payoff plan", "debt free"],
    },
];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);
